export const getRefElement = (element) => {
  if (element && element.current) {
    return element.current
  }
  return element
}